<div
  class="field-group cursor-pointer l_flex-column"
  data-dgat="assignment-content-container-3984j"
>
  <label for="assignment-content-search-input">{{
    i18n.recommendationForm_ContentName
  }}</label>
  <div
    class="field-group__input field-group__input--tag l_flex"
    [ngClass]="{ 'guts-p-l-0': !selectedItem.title }"
  >
    <button
      *ngIf="selectedItem.title"
      df-button
      dfButtonType="clear"
      df-button-small
      class="bg-color-ebony-a08 color-ebony guts-m-l-quart guts-m-v-half guts-m-r-half assignment-content-tag"
      (click)="removeSelection()"
      data-dgat="assignment-selected-content-9324h"
    >
      <span class="l_flex l_flex-top-children l_flex-wrap guts-p-r-1-half"
        >{{ selectedItem.title }}
      </span>
      <df-icon icon="cross" size="small" class="color-ebony"></df-icon>
    </button>
    <input
      *ngIf="!selectedItem.title"
      id="assignment-content-search-input"
      data-dgat="assignment-content-search-sd89"
      class="assignment-input--full-width"
      [ngClass]="{ 'guts-p-l-1': !selectedItem.title }"
      autocomplete="off"
      [attr.aria-errormessage]="'assignment-content-search-input-error'"
      type="text"
      [placeholder]="i18n.recommendationForm_SearchForContent"
      [required]="true"
      [(ngModel)]="inputText"
      [ngbTypeahead]="onSearch"
      placement="bottom-start"
      [resultTemplate]="searchResultsTemplate"
      (blur)="onBlur()"
      (selectItem)="onSelect($event)"
      (keydown)="onKeydown($event)"
    />
  </div>
</div>

<!-- template for search results -->
<ng-template #searchResultsTemplate let-result="result" let-term="term">
  <div class="guts-p-full-half assignment-results">
    <dgx-content-result
      [item]="result"
      [endorsedSrc]="result.isEndorsed ? endorsedSrc : ''"
    ></dgx-content-result>
  </div>
</ng-template>
